export default "__VITE_ASSET__BFFqKkUv__"